import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/appointments/appointmentRow.template.html';

import Model from '../../models/appointments/appointment.model.ts';

import i18n  from "l10n";

export default Backbone.View.extend({
    tagName: 'tr',
    className: 'col-12 ticketRow no-padding',
	template: Handlebars.compile(Template),
    model: null,
    stompSubscription: null,
    initialize: function (options) {
        var self = this;

        this.stompSubscription = null;

        if(options && options.model) {
            this.model = new Model(options.model);
        }
        else {
            this.model = new Model({
                "appointmentId": -1,
                "customerCode": "-",
                "queueName": "-",
                "queueEnglishName": "-",
                "date": "-",
            });

        }

        this.wsocket = options ? options.wsocket : null;
        this.client = options ? options.client : null;

        this.render();

        this.subscribeToStomp(this);
	},
	superRender: Backbone.View.prototype.render,
	render: function (withAnimation) {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.model.toJSON(), {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        if(withAnimation)
             this.$el.removeClass("with-animation").addClass("with-animation");

        return this;
	},
	events:{
	},
	setupAjax: function() {
        var self = this;

        $.ajaxSetup({
            beforeSend: function (xhr) {
                var lang = i18n.lng() == "en" ? "en-GB" : "el-GR";

                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                xhr.setRequestHeader('X-Client-Type', self.clientType);
                xhr.setRequestHeader('X-Client-Auth', self.clientAuth);
                xhr.setRequestHeader('Accept-Language', lang);

            },
            error: function (xhr, exception) {

            }
        });
    },
    subscribeToStomp: function(self) {

        if(self.stompSubscription != null) // already subscribed
            return;

        self.stompSubscription = self.client.subscribe("/live/monitors/appointments/" + self.model.get("appointmentId"), function (message){
            var responseObject = JSON.parse( message.body );

            if(responseObject.object == "DELETE") {
                self.$el.remove();
                return;
            }

            self.model = new Model(responseObject.object);
            self.render(true);
        });
    }
});


